import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const StatusMediumIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 12 12" fill="currentColor" {...props}>
      <path d="m1 6 5-5 5 5-5 5-5-5Z" />
    </Icon>
  )
);
export default StatusMediumIcon;
